var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseHomeStream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseHomeStream") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.37223567,7.5800354 L14.7488099,2.20345485 C15.24373,1.70853415 15.24373,0.906111221 14.7488099,0.411261327 C14.2538898,-0.0836593703 13.4515386,-0.0836593703 12.9566185,0.411261327 L7.57997345,5.78791269 L2.2033284,0.411190523 C1.70840828,-0.0837301744 0.906057101,-0.0837301744 0.411136984,0.411190523 C-0.0837123281,0.906111221 -0.0837123281,1.70853415 0.411136984,2.20338404 L5.78778203,7.5799646 L0.411136984,12.956616 C-0.0837123281,13.4515367 -0.0837123281,14.2539596 0.411136984,14.7488095 C0.906057101,15.2437302 1.70840828,15.2437302 2.2033284,14.7488095 L7.57997345,9.37215812 L12.9566185,14.7488095 C13.4514678,15.2437302 14.2538898,15.2437302 14.7488099,14.7488095 C15.24373,14.2538888 15.24373,13.4515367 14.7488099,12.956616 L9.37223567,7.5800354 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friends-request-Accepted",
    transform: "translate(-275.000000, -168.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/General/Cross",
    transform: "translate(275.000000, 168.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloseHomeStream",
    fill: "#A5A5A5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseHomeStream);
export default __webpack_public_path__ + "static/media/icCloseHomeStream.45e4cb75bcdfde1b1fe4ce4225f9bbc9.svg";
export { ForwardRef as ReactComponent };